import React from 'react'
import { Breadcrumbs, Link } from 'chemistry'

const ProductBreadCrumbs = props => {
  const { breadcrumbs } = props

  return (
    <nav data-testid='pdp-breadcrumbs' className='mxd-pdp-breadcrumbs'>
      <Breadcrumbs itemScope itemType='http://schema.org/BreadcrumbList'>
        {breadcrumbs.map(({ path, categoryName }, i) => {
          const current = breadcrumbs?.length - 1 === i

          return (
            <Breadcrumbs.Crumb key={path} itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem'>
              <Link href={path} itemProp='item' {...(current && { 'aria-current': 'page' })}>
                <span itemProp='name'>{categoryName}</span>
              </Link>
              <meta itemProp='position' content={i + 1} />
            </Breadcrumbs.Crumb>
          )
        })}
      </Breadcrumbs>
    </nav>
  )
}

export default ProductBreadCrumbs
